import { Component, OnInit } from '@angular/core';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { moduli } from '../../config';
import { OstvareniSatiService } from './ostvareni-sati.service';

@Component({
  selector: 'app-ostvareni-sati',
  templateUrl: './ostvareni-sati.component.html',
  styleUrls: ['./ostvareni-sati.component.scss'],
})
export class OstvareniSatiComponent implements OnInit {
  datumOd = moment();
  datumDo = moment();
  backendDate: string = 'YYYY-MM-DD';
  ostvareniSati: any;
  linije: any;
  linija: number;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: OstvareniSatiService) {
    this.dohvatiSveLinije();
    this.dohvatiOstvareneSate(
      moment(this.datumOd).format(this.backendDate),
      moment(this.datumDo).format(this.backendDate),
      this.linija
    );

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().ostvareniSati;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {}

  dohvatiOstvareneSate(datumod: string, datumdo: string, linija: number): void {
    this.ostvareniSati = [];
    const data = {
      datumod: moment(datumod).format(this.backendDate),
      datumdo: moment(datumdo).format(this.backendDate),
      linija: linija ? linija : 0,
    };
    console.log(data);
    this.service.dohvatiOstvareneSate(data).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        this.ostvareniSati = res.djelatnikostvareno;
      }
    });
  }

  dohvatiSveLinije() {
    this.service.dohvatiSveLinije({}).subscribe((res) => {
      console.log(res);
      if (res.success == true) {
        this.linije = [{ idlinija: 0, li_naziv: 'SVE' }, ...res.data];
      }
    });
  }

  onValueChangedDatumOd(e) {
    this.datumOd = e.value;
    this.dohvatiOstvareneSate(
      moment(this.datumOd).format(this.backendDate),
      moment(this.datumDo).format(this.backendDate),
      this.linija
    );
  }

  onValueChangedDatumDo(e) {
    this.datumDo = e.value;
    this.dohvatiOstvareneSate(
      moment(this.datumOd).format(this.backendDate),
      moment(this.datumDo).format(this.backendDate),
      this.linija
    );
  }

  promjenaLinije(e) {
    console.log(e);
    this.linija = e.value;
    this.dohvatiOstvareneSate(
      moment(this.datumOd).format(this.backendDate),
      moment(this.datumDo).format(this.backendDate),
      this.linija
    );
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }
}
